<template>
  <div>
    <user-selector
      v-if="!detail"
      v-model="produit.assistantId"
      :label="$t('addEditRegroupementProduit.informationProduits.assistant')"
      :critere="(u) => u.profil === constantes.ASSISTANT_COMMERCIAL"
      :disabled="disabledVal"
    />
    <div v-else>
      <p class="has-text-default is-italic">
        {{ $t('addEditRegroupementProduit.informationProduits.assistant') + ' :' }}
      </p>
      <p class="has-text-weight-bold">{{ assistant }}</p>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { ASSISTANT_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import messageErreur from '@/services/general/messageErreur';
import userSelector from '@/components/commun/user/userSelector';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'CatalogueProduitGeneralPresseAssistant',
  props: {
    produit: {
      type: Object,
      required: false,
    },
    detail: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
    },
  },
  components: {
    userSelector,
  },
  data() {
    return {
      constantes: {
        ASSISTANT_COMMERCIAL,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    assistant() {
      const find = this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur)
        .find(u => u.id === this.produit.assistantId);
      if (!find) return '';
      return find.decorator.nomPrenom;
    },
    disabledVal() {
      if (typeof this.disabled === 'boolean') return this.disabled;
      return !!this.produit.regroupementProduitId;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
